(function(env){
    const hostname = location.hostname
    if(hostname.includes('localhost') ||
    hostname.includes('127.0.0.1') ||
    hostname.includes('cem-uat.oppoit.com') ||
    hostname.includes('cem-test.wanyol.com')

){
        env.IS_DEV = true
}
})(window.env);